import { User } from '@/Services/Auth/types';

import { checkTokens } from './checkTokens';

export const checkUser = (user: Partial<User>) => {
    if (user && user.is_company_admin !== undefined && user.is_super !== undefined && user.permissions !== undefined && checkTokens(user.tokens)) return true;

    return false;
};
